export interface TransportOrderOverviewLocation {
  extId?: string;
  name: string;
  address: string;
}

export interface TransportOrderOverviewTransportDetails {
  transportModes: string[];
  transportServices: string[];
  carriageConditions: string[];
}

export interface TransportOrderOverviewIdentificationNumbers {
  houseBillOfLading: string;
  masterBillOfLading: string;
  houseAirwayBill: string;
  masterAirwayBill: string;
}

export interface TransportOrderOverviewData {
  transportOrderNumber: string;
  carrierId: string;
  carrierName: string;
  statusCodeDescription: string;
  origin: TransportOrderOverviewLocation;
  destination: TransportOrderOverviewLocation;
  transportDetails: TransportOrderOverviewTransportDetails;
  identificationNumbers: TransportOrderOverviewIdentificationNumbers;
}
